<template>
  <div class="static-content">
    <Collapser
      class="mt-32"
      :collapserTitle="$t('staticCustomerInformationTile.provisionalInsurance.title')"
    >
      <template #collapserContent>
        <p class="mt-16">
          {{ $t('staticCustomerInformationTile.provisionalInsurance.helptext') }}
        </p>
      </template>
    </Collapser>
    <Collapser
      class="mt-32"
      :collapserTitle="$t('staticCustomerInformationTile.withdrawal.title')"
    >
      <template #collapserContent>
        <p class="mt-16">
          {{ $t('staticCustomerInformationTile.withdrawal.rights') }}
        </p>
      </template>
    </Collapser>
  </div>
</template>

<script setup lang="ts">
import { Collapser } from 'de-zurich-ui-library'
</script>

<style scoped lang="scss">
.static-content {
  padding-bottom: 16px;
}
</style>
